// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1ZUtD","question":"Question_question__1p_6q","description":"Question_description__1iT9X"};